import { version } from '../../package.json';
import type{ TEnvironmentName } from '@/types';

export const ENV = {
  baseUrlApi: import.meta.env.VITE_API_BASE_URL as string,
  gcClientId: import.meta.env.VITE_GC_CLIENT_ID as string,
  metabasePublicDashboardUrl: import.meta.env.VITE_METABASE_PUBLIC_DASHBOARD_URL as string,
  name: import.meta.env.VITE_APP_ENV as TEnvironmentName,
  version
};
